
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassadors/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/ambassadors/[id]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambassadors/[id]/[[...slug]]"])
      });
    }
  